(function() {
  if (window._cartitemsLoaded) return;
  window._cartitemsLoaded = true;

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` },
  };
}

class Cookies {
  static readCookie(name) {
    const nameEQ = encodeURIComponent(name) + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }

    return null;
  }

  static createCookie(name, value, days = 360) {
    let expires;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toISOString();
    } else {
      expires = '';
    }
    document.cookie =
      encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
  }
}

const errorLocalStorageUnavailable = 'Local Storage unavailable';
class Storage {
  static read(key, defaultValue) {
    if (this.isLocalStorageAvailable()) {
      return this.readFromLocalStorage(key, defaultValue);
    } else {
      const cookieValue = Cookies.readCookie(key);

      if (cookieValue) {
        return cookieValue ;
      } else {
        return defaultValue;
      }
    }
  }

  static write(key, value) {
    if (this.isLocalStorageAvailable()) {
      this.writeToLocalStorage(key, value);
    } else {
      Cookies.createCookie(key, '' + value, 365);
    }
  }

  static writeObject(key, value) {
    if (this.isLocalStorageAvailable()) {
      this.writeToLocalStorage(key, value);
    } else {
      throw Error(errorLocalStorageUnavailable);
    }
  }

  static remove(key) {
    this.removeFromLocalStorage(key);
  }

   static isLocalStorageAvailable() {
    let isAvailable = false;

    try {
      const valueToStore = 'test';
      const key = 'key';
      localStorage.setItem(key, valueToStore);
      const recoveredValue = localStorage.getItem(key);
      localStorage.removeItem(key);

      isAvailable = recoveredValue === valueToStore;
    } catch (e) {
      isAvailable = false;
    }

    return isAvailable;
  }

   static writeToLocalStorage(key, value) {
    if (!this.isLocalStorageAvailable()) throw Error(errorLocalStorageUnavailable);

    localStorage.setItem(key, JSON.stringify(value));
  }

   static readFromLocalStorage(key, defaultValue) {
    if (!this.isLocalStorageAvailable()) throw Error(errorLocalStorageUnavailable);

    const dataFromStorage = localStorage.getItem(key);

    if (!dataFromStorage) return defaultValue;

    try {
      return JSON.parse(dataFromStorage) ;
    } catch (e) {
      return dataFromStorage ? (dataFromStorage ) : defaultValue;
    }
  }

   static removeFromLocalStorage(key) {
    if (!this.isLocalStorageAvailable()) throw Error(errorLocalStorageUnavailable);
    localStorage.removeItem(key);
  }
}

function debounce(fn, wait) {
  let t;

  return (...args) => {
    clearTimeout(t);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* eslint-disable @typescript-eslint/no-explicit-any */
class CartItems extends HTMLElement {
  
  

  
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.addEventListener('click', (event) => {
      const target = event.target ;
      if (target.hasAttribute('data-update-btn')) {
        this.onUpdateClick(target );
      }
      if (target.hasAttribute('data-edit-btn')) {
        this.onEditClick(target);
      }
      if (target.hasAttribute('data-cancel-btn')) {
        this.onCancelClick(target);
      }
    });
  }

  onEditClick(btn) {
    const container = btn.closest('.cart-item__edit-container');
    if (!container) return;

    const staticView = container.querySelector('.cart-item__static-view');
    const editView = container.querySelector('.cart-item__edit-view');
    const updateBtn = container.querySelector('[data-update-btn]') ;

    if (staticView && editView) {
      staticView.classList.add('hidden');
      editView.classList.remove('hidden');

      // Hide update button when entering edit mode - it should only show when options change
      if (updateBtn) {
        updateBtn.classList.add('hidden');
        updateBtn.disabled = false;
      }
    }
  }

  onCancelClick(btn) {
    const container = btn.closest('.cart-item__edit-container');
    if (!container) return;

    const staticView = container.querySelector('.cart-item__static-view');
    const editView = container.querySelector('.cart-item__edit-view');
    const updateBtn = container.querySelector('[data-update-btn]') ;

    if (staticView && editView) {
      // Revert selections
      if (updateBtn && updateBtn.dataset.originalVariantId) {
        const originalVariantId = parseInt(updateBtn.dataset.originalVariantId);
        const variantsJson = container.querySelector('[data-variants-json]');

        if (variantsJson && variantsJson.textContent) {
          const variants = JSON.parse(variantsJson.textContent);
          const originalVariant = variants.find((v) => v.id === originalVariantId);

          if (originalVariant) {
            // Iterate originalVariant.options
            originalVariant.options.forEach((optionValue, index) => {
              // Find the input for this option index with this value
              // The inputs are in fieldsets.
              const fieldsets = container.querySelectorAll('.product-form__input');
              if (fieldsets[index]) {
                const inputToSelect = Array.from(fieldsets[index].querySelectorAll('input')).find(
                  (i) => i.value === optionValue
                );
                if (inputToSelect) {
                  (inputToSelect ).checked = true;
                } else {
                  console.warn('Could not find input for value:', optionValue);
                }
              }
            });

            // Update statuses to reflect reverted state
            this.updateVariantStatuses(container.closest('.cart-item'), variants);

            // Reset update button
            updateBtn.classList.add('hidden');
            updateBtn.disabled = false;
          }
        }
      }

      staticView.classList.remove('hidden');
      editView.classList.add('hidden');
    }
  }

   displayInlineCartNotifications() {
    const cartMessage = Storage.read('saveForLaterNotification', '');
    if (cartMessage !== '') {
      this.displaySaveForLaterNotification(cartMessage);
    }

    const lineItemUndo = Storage.read('undoRemoveCartItem', '');
    if (lineItemUndo !== '') {
      this.displayUndoNotification(lineItemUndo);
    }

    // close button click
    document
      .querySelector('.cart-inline-notification svg')
      .addEventListener('click', () => {
        this.toggleInlineNotification();
      });
  }

   displaySaveForLaterNotification(notification) {
    Storage.remove('saveForLaterNotification');
    const cartNotification = document.querySelector('.cart-inline-notification');
    if (cartNotification) {
      cartNotification.querySelector('span').innerHTML = notification;
      setTimeout(() => {
        this.toggleInlineNotification('false');
      }, 10000);

      this.toggleInlineNotification('true');
    }
  }

  convertArrayToObject(arr) {
    return arr.reduce((obj, [key, value]) => {
      obj[key] = value;

      return obj;
    }, {});
  }

   displayUndoNotification(notification) {
    window.scrollTo(0, 0);
    const cartNotification = document.querySelector('.cart-inline-notification');
    if (cartNotification) {
      cartNotification.querySelector(
        'span'
      ).innerHTML = `Removed ${notification.title}. <strong class='button-undo'>Undo?</strong>`;

      _optionalChain([cartNotification, 'access', _ => _.querySelector, 'call', _2 => _2('.button-undo'), 'optionalAccess', _3 => _3.addEventListener, 'call', _4 => _4('click', () => {
        const lineItemUndo = Storage.read('undoRemoveCartItem', '');

        const properties = this.convertArrayToObject(lineItemUndo.properties);

        const undoCart = {
          id: lineItemUndo.item.id,
          quantity: lineItemUndo.quantity,
          properties,
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [undoCart],
          }),
        }).then(() => {
          Storage.remove('undoRemoveCartItem');
          window.location.reload();
        });
      })]);

      this.toggleInlineNotification('true');

      setTimeout(() => {
        this.toggleInlineNotification('false');
        Storage.remove('undoRemoveCartItem');
      }, 10000);
    }
  }

   toggleInlineNotification(visible = '') {
    const cartNotification = document.querySelector('.cart-inline-notification');
    if (visible !== '') {
      cartNotification.toggleAttribute('aria-expanded', visible === 'true');
    } else {
      cartNotification.toggleAttribute('aria-expanded');
    }

    if (cartNotification.hasAttribute('aria-expanded')) {
      // set wrapper height to allow space for absolutely positioned notification element
      cartNotification.parentElement.style.height = cartNotification.offsetHeight + 'px';
    } else {
      setTimeout(() => {
        // allow closing animation to finish before setting height
        cartNotification.parentElement.style.height = 'unset';
      }, 200);
    }
  }

  onChange(event) {
    if (event.target.classList.contains('quantity__input')) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        _optionalChain([document, 'access', _5 => _5.activeElement, 'optionalAccess', _6 => _6.getAttribute, 'call', _7 => _7('name')])
      );
    } else {
      this.onOptionChange(event);
    }
  }

  onOptionChange(event) {
    const input = event.target ;
    const lineItem = input.closest('.cart-item');
    if (!lineItem) return;

    const updateBtn = lineItem.querySelector('[data-update-btn]') ;
    if (!updateBtn) return;

    const variantsJson = lineItem.querySelector('[data-variants-json]');
    if (!variantsJson || !variantsJson.textContent) return;

    const variants = JSON.parse(variantsJson.textContent);

    // Update statuses (OOS logic)
    this.updateVariantStatuses(lineItem, variants);

    // Get all selected options for this line item
    const selectedOptions = Array.from(
      lineItem.querySelectorAll('input[type="radio"]:checked')
    ).map((radio) => radio.value);

    // Find matching variant
    const matchedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (matchedVariant) {
      const originalVariantId = parseInt(updateBtn.dataset.originalVariantId || '0');

      // Check if this is a different variant from the original
      if (matchedVariant.id !== originalVariantId) {
        // Check if the matched variant is available
        if (matchedVariant.available) {
          updateBtn.classList.remove('hidden');

          updateBtn.disabled = false;
          updateBtn.dataset.newVariantId = matchedVariant.id;
        } else {
          // Show button but disable it for out of stock variants

          updateBtn.classList.remove('hidden');
          updateBtn.disabled = true;
          updateBtn.dataset.newVariantId = matchedVariant.id;
        }
      } else {
        // Same variant as original, hide the button

        updateBtn.classList.add('hidden');
        updateBtn.disabled = false;
      }
    } else {
      // No matching variant found, hide and disable button

      updateBtn.classList.add('hidden');
      updateBtn.disabled = true;
    }
  }

  updateVariantStatuses(lineItem, variants) {
    const inputWrappers = [...lineItem.querySelectorAll('.product-form__input')];
    if (!inputWrappers.length) return;

    let selectedOptionOneVariants = variants;
    let optionInputs = [];
    let availableOptionInputsValue = [];

    if (inputWrappers.length === 1) {
      optionInputs = [...inputWrappers[0].querySelectorAll('input[type="radio"], option')];
      availableOptionInputsValue = variants
        .filter((variant) => variant.available)
        .map((variant) => variant.option1);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    } else {
      // Filter variants based on first option selection
      const firstOptionSelected = _optionalChain([(inputWrappers[0].querySelector(':checked') )
, 'optionalAccess', _8 => _8.value]);

      if (firstOptionSelected) {
        selectedOptionOneVariants = variants.filter(
          (variant) => variant.option1 === firstOptionSelected
        );
      }

      inputWrappers.forEach((option, index) => {
        // Skip first option as it drives the others
        if (index === 0) return;

        optionInputs = [...option.querySelectorAll('input[type="radio"], option')];

        const previousOptionSelected = _optionalChain([(
          inputWrappers[index - 1].querySelector(':checked') 
        ), 'optionalAccess', _9 => _9.value]);

        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);

        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });

      // Handle first option availability
      const firstOptionInputs = [
        ...inputWrappers[0].querySelectorAll('input[type="radio"], option'),
      ];
      const firstOptionAvailableValues = variants
        .filter((variant) => variant.available)
        .map((variant) => variant.option1);
      this.setInputAvailability(firstOptionInputs, firstOptionAvailableValues);
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const inputValue = input.getAttribute('value');
      const label = input.nextElementSibling;
      const isAvailable = listOfAvailableOptions.includes(inputValue);

      if (isAvailable) {
        input.classList.remove('disabled');
        if (label) {
          label.classList.remove('strikeout');
        }
        input.disabled = false;
      } else {
        input.classList.add('disabled');
        if (label) {
          label.classList.add('strikeout');
        }
        input.disabled = true;
      }
    });
  }

  connectedCallback() {
    // Initial status update for all items
    this.querySelectorAll('.cart-item').forEach((item) => {
      const variantsJson = item.querySelector('[data-variants-json]');
      if (variantsJson && variantsJson.textContent) {
        this.updateVariantStatuses(item, JSON.parse(variantsJson.textContent));
      }
    });
  }

  onUpdateClick(btn) {
    const line = btn.dataset.lineIndex;
    const lineKey = btn.dataset.lineKey;
    const newVariantId = btn.dataset.newVariantId;
    const oldVariantId = btn.dataset.originalVariantId;

    // Get current quantity
    const quantityInput = document.getElementById(`Quantity-${line}`) ;
    const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

    if (lineKey && newVariantId && oldVariantId) {
      this.updateVariant(line, lineKey, newVariantId, quantity, oldVariantId);
    }
  }

  async updateVariant(line, lineKey, newVariantId, quantity, oldVariantId) {
    this.enableLoading(line);

    const lineItem = document.getElementById(`CartItem-${line}`);
    const properties = {};

    if (lineItem) {
      const propertyElements = lineItem.querySelectorAll('[data-property-name]');
      propertyElements.forEach((el) => {
        const propName = el.dataset.propertyName;
        const propValue = el.dataset.propertyValue || el.value;
        if (propName && propValue) {
          properties[propName] = propValue;
        }
      });
    }

    const body = JSON.stringify({
      items: [{ id: parseInt(newVariantId), quantity, properties }],
    });

    try {
      const addResponse = await fetch(`${window.routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{ body },
      });

      if (!addResponse.ok) {
        if (addResponse.status === 422) {
          const data = await addResponse.json();
          const message = typeof data.errors === 'string' ? data.errors : window.cartStrings.error;

          this.showItemAvailabilityMessage(line, message);
          await new Promise((resolve) => setTimeout(resolve, 2000));
        } else {
          throw new Error(window.cartStrings.error);
        }
      }

      const changeBody = JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      const changeResponse = await fetch(`${window.routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body: changeBody },
      });

      const state = await changeResponse.text();
      const parsedState = JSON.parse(state);

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const sectionEl = document.getElementById(section.id);
        if (!sectionEl) return;

        const elementToReplace = sectionEl.querySelector(section.selector) || sectionEl;

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      this.currentItemCount = parsedState.item_count;

      this.querySelectorAll('.cart-item').forEach((item) => {
        const variantsJson = item.querySelector('[data-variants-json]');
        if (variantsJson && variantsJson.textContent) {
          this.updateVariantStatuses(item, JSON.parse(variantsJson.textContent));
        }
      });

      this.disableLoading();
    } catch (error) {
      this.querySelectorAll('.loading-overlay').forEach((overlay) =>
        overlay.classList.add('hidden')
      );
      const errorContainer = document.getElementById('cart-errors');
      if (errorContainer)
        errorContainer.textContent = (error).message || window.cartStrings.error;
      this.disableLoading();
      (window ).Bugsnag.notify(error);
    }
  }

  showItemAvailabilityMessage(line, message) {
    const lineItem = document.getElementById(`CartItem-${line}`);
    if (!lineItem) return;

    const errorEl = lineItem.querySelector('.cart-item__error');
    const textEl = lineItem.querySelector('.cart-item__error-text');

    if (errorEl && textEl) {
      textEl.textContent = message;
      errorEl.style.display = 'flex';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',

        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'combined-cart',
        section: 'combined-cart',
        selector: '.totals',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      // eslint-disable-next-line camelcase
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        const sectionsToRender = this.getSectionsToRender();

        sectionsToRender.forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const elementToReplace = sectionEl.querySelector(section.selector) || sectionEl;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          (lineItem.querySelector(`[name="${name}"]`) ).focus();
        }
        this.disableLoading();
        if (Number(quantity) === 0) {
          this.displayInlineCartNotifications();
        }
      })
      .catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden')
        );
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();

        (window ).Bugsnag.notify(error);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`);
      const errorTextEl = lineItemError?.querySelector('.cart-item__error-text');
      const quantityInput = document.getElementById(`Quantity-${line}`);

      if (errorTextEl && quantityInput) {
        errorTextEl.innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityInput.value
        );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', 'true');

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return (
      new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML || null
    );
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) =>
      overlay.classList.remove('hidden')
    );
    (document.activeElement ).blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', 'false');
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    const saveForLater = this.dataset['saveToWishlist'] === 'true';
    const product = JSON.parse(
      this.querySelector('script[type="application/json"]').textContent
    );

    this.addEventListener('click', async (event) => {
      event.preventDefault();

      if (saveForLater) {
        // save item to wishlist before removing from cart
        await window.WishlistClient.addToWishlist({
          ...product,
          // eslint-disable-next-line camelcase
          product_id: product.id,
          product: product,
        });

        // store data used to render save for later notification in CartItems web component
        Storage.write(
          'saveForLaterNotification',
          `<a href='/products/${product.handle}'>${product.title}</a> has been saved to your wishlist`
        );
      } else {
        // store undo data used to render undo notification in CartItems web component
        Storage.writeObject('undoRemoveCartItem', {
          item: { id: product.id },
          title: product.title,
          properties: product.properties,
          quantity: product.quantity,
        });
      }

      // update cart page
      (this.closest('cart-items') ).updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

})();